var $ = require('jquery')

module.exports = function requireLogin(callback, cate) {

  return function() {
    var Passport = window.Passport || {}
      , args = arguments
      , voteMobileBinderTit = '亲爱的玩家，您需要绑定手机号后才能给游戏投票哦~'
      , mobileBinderTit
      , isRequireMobileBind = false
      , markIsNoTopbarTrigger = true //标记是非Topbar登陆触发的Passport,用于事件隔离

    if (cate) {
      isRequireMobileBind = true
    }

    if (cate == 'vote') {
      mobileBinderTit = voteMobileBinderTit
    }

    function requireMobileBind() {
      Passport.getMobileStatus(function(isBinded){
        if (!isBinded) {
          //手机未绑定，弹出手机绑定弹窗
          Passport.Dialog.showMobileBinder();
          var ti = setInterval(function(){
            if($('#nut').contents().find('.gpp-tel-bind .pprt-bindMobile-el .gpp-tit').length){
                clearInterval(ti);
                $('#nut').contents().find('.gpp-tel-bind .pprt-bindMobile-el .gpp-tit').text(mobileBinderTit).css('line-height','22px');
            }
          },500);
        }else {
          //手机已绑定，去执行回调
          callback.apply(this, args)
        }
      });
    }

    function newgameLoginSuccess() {
      if (isRequireMobileBind) {
        requireMobileBind();
        return
      }
      //登陆成功，不需要手机绑定，去执行回调
      callback.apply(this, args)
    }

    if(typeof passportDialogEventBind === 'undefined'){
      Passport.on(Passport.EVENTS.dialogClose, function (events) {
        window.passportDialogEventBind = true; //防止多次绑定
        if (events.dialogType == 'login') {
          //关闭登录弹窗，取消绑定
          window.Passport.off('loginSuccess', newgameLoginSuccess)
        }
        if (events.dialogType == 'mobileBind') {
          if (markIsNoTopbarTrigger) {  //事件隔离
            Passport.getMobileStatus(function(isBinded){
              if (isBinded) {
                //手机绑定成功，去操作
                callback.apply(this, args)
              }
            });
          }
        }
      });
    }

    if (Passport && Passport.defaultOption) {
      Passport.defaultOption.mobileBindOn=false
    }

    if(!Passport.isLoggedIn()){
      // 没有登陆
      Passport.off('loginSuccess', newgameLoginSuccess)
      Passport.Dialog.show()
      Passport.on('loginSuccess', newgameLoginSuccess)
    } else {
      // 有登陆
      if (isRequireMobileBind) {
        // 需要手机绑定
        requireMobileBind();
      } else {
        // 不需要手机绑定
        callback.apply(this, args)
      }
    }

  }
}
